// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-header-ios {
  padding: 0;
  margin: 0 auto;
}

.list-header-md {
  padding: 0;
}

.lateral-color-section {
  width: 5px;
  height: 55px;
  background: grey;
  opacity: 0.4;
  float: left;
}

.lateral-color-card-ok,
.lateral-color-card-warn {
  width: 5px;
  height: 55px;
  float: left;
}

.lateral-color-card-warn {
  background: #CEA244;
}

.lateral-color-card-ok {
  background: #72B746;
}

.card-content {
  margin: 0 auto;
  width: 100%;
}

.bg-content {
  background: #eeeeee;
}
.bg-content .icon-survey-size {
  font-size: 30px;
  margin-right: 5px;
  position: relative;
  top: 5px;
}

ion-item-divider {
  padding: 0;
  margin: 0;
}

ion-toolbar {
  border-radius: 0;
}
ion-toolbar p {
  font-family: var(--font);
  font-weight: 700;
  font-size: 20px;
}

@media screen and (min-width: 768px) {
  ion-toolbar ion-title p {
    text-align: left;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/quiz-list-page/quiz-list-page.page.scss"],"names":[],"mappings":"AAUA;EACI,UAAA;EACA,cAAA;AATJ;;AAYA;EACI,UAAA;AATJ;;AAYA;EACI,UAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;AATJ;;AAaA;;EAEI,UAAA;EACA,YAAA;EACA,WAAA;AAVJ;;AAaA;EACI,mBAAA;AAVJ;;AAaA;EACI,mBAAA;AAVJ;;AAaA;EACI,cAAA;EACA,WAAA;AAVJ;;AAaA;EACI,mBAAA;AAVJ;AAYI;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAVR;;AAcA;EACI,UAAA;EACA,SAAA;AAXJ;;AAaA;EACI,gBAAA;AAVJ;AAWI;EACI,wBAAA;EAA0B,gBAAA;EAC1B,eAAA;AARR;;AAWA;EAGQ;IACI,gBAAA;EAVV;AACF","sourcesContent":["// ion-title {\n//     position: absolute;\n//     top: 0;\n//     left: 0;\n//     width: 100%;\n//     height: 100%;\n//     text-align: center;\n//     text-transform: uppercase;\n// }\n\n.list-header-ios {\n    padding: 0;\n    margin: 0 auto;\n}\n\n.list-header-md {\n    padding: 0;\n}\n\n.lateral-color-section {\n    width: 5px;\n    height: 55px;\n    background: grey;\n    opacity: 0.4;\n    float: left;\n}\n\n\n.lateral-color-card-ok,\n.lateral-color-card-warn {\n    width: 5px;\n    height: 55px;\n    float: left;\n}\n\n.lateral-color-card-warn {\n    background: #CEA244;\n}\n\n.lateral-color-card-ok {\n    background: #72B746;\n}\n\n.card-content {\n    margin: 0 auto;\n    width: 100%;\n}\n\n.bg-content {\n    background: #eeeeee;\n\n    .icon-survey-size {\n        font-size: 30px;\n        margin-right: 5px;\n        position: relative;\n        top: 5px;\n    }\n}\n\nion-item-divider {\n    padding: 0;\n    margin: 0;\n}\nion-toolbar{\n    border-radius: 0;\n    p{\n        font-family: var(--font); font-weight: 700;;\n        font-size: 20px;\n    }\n}\n@media screen and (min-width: 768px) {\n    ion-toolbar{\n        // border-radius: 37px;\n        ion-title p{\n            text-align: left;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
